import type { FaireProductEntity } from "../../entity_types/product";

export const p_y755tjwxy3: FaireProductEntity = {
  token: "p_y755tjwxy3",
  type: "product",
  name: "Patterned Bohemian Casual Dress",
  brandToken: "b_ysnwrcjujg",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/23ade1721c22d394eae60ec64310affe1fe17763bb557e3155ce6fc60c1daae0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43505cad65366621f4e95a490cdaae1623beeece7b33aea94ccea392faed7ba8.jpeg",
    "https://cdn.faire.com/fastly/786936c071301c4918dd503a2619375b31a3551028784eef78102f7f33eb9fe7.jpeg",
    "https://cdn.faire.com/fastly/df1eb13633f2443566cea6270958061bf03c47fa705f78c496924040d2b19a59.jpeg",
    "https://cdn.faire.com/fastly/d730d71d278e554d4c40b33f5806ba50d87fe364ebed7e6226106fdd53c4422d.jpeg",
    "https://cdn.faire.com/fastly/0756da0b2404fb449b7ce4f8d35155e11bf7c2e76f1239f337cee7eae5b25279.jpeg"
  ],
  priceDollars: 25.89,
  description: "Your new favorite dress offers a chic bohemian flair with its stunning patterns. Perfect for casual outings, this dress seamlessly combines style and comfort.\n\nFabric: 100% polyester\n\nWeight: 0.77 lb\n",
  tags: [],
  msrpDollars: 51.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:46.437Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
